'use strict';

// NVTagView.js: Main file for the Tag.
//   It is the master controller of most things. Waits for DOM ready given its
//   tight coupling to the DOM for a lot of what it does.
/*jshint -W098 */
define('NVTagView',[
  'backbone.subviews',
  'spin',
  'doublebracket',
  'errorviews',
  'oberon',
  'trackTransaction',
  'accounting',
  'NVFormView',
  'NVForm',
  'FormError',
  'FormDefUtils',
  'FormElements',
  'NVTagCallbacks',
  'databag',
  'node-querystring',
  'parseUrl',
  'qs.params',
  'socialSharePopup',
  'socialMediaLogger',
  'Map',
  'SignaturePad',
  'vgs',
  'html2canvasWrapper',
  'deviceInfo',
  'databag_config',
  'lightboxHelper',
  'checkAds',
  'aliasHelper',
], function (Backbone, Spinner, DoubleBracket, ErrorViews, oberon, trackTransaction, accounting,
             NVFormView, NVForm, FormError, FormDefUtils, form_elements, invokeCallbacks,
             DatabagModel, node_query_string, parseUrl, qsParams, socialSharePopup,
             socialMediaLogger, Map, SignaturePad, vgs, html2canvasWrapper, deviceInfo, databag_config, lightboxHelper, checkAds, aliasHelper) {
  /*jshint +W098 */
  var $ = Backbone.$,
    _ = Backbone._;

  // Always initialize VGS in case we need it
  vgs.init();

  function FormViewArray() {
    this.current = null;
  }

  FormViewArray.prototype = [];
  FormViewArray.prototype.getCurrent = function () {
    return this.current;
  };
  FormViewArray.prototype.setCurrent = function (view) {
    this.current = view;
    return this;
  };

  return Backbone.View.extend({
    __name__: 'NVTagView',
    interstitial: false,
    events: {
      'submit form': 'postBack',
      'click #rta-link': 'closeWindowRedirect'
    },
    /**
     * Redirect the window then close the window
     */
    closeWindowRedirect: function() {
      var qs = this.options.query_string;
      window.location = qs.redirect;
      setTimeout(function() {
        //Allow time for browser to redirect before closing window
        window.close();
      }, 8000);

    },
    databagShareSetting: function () {
      return this.options.databagShareSetting;
    },
    currentFormView: function () {
      return this.formviews.getCurrent();
    },
    bringIntoView: function () {
      $('html, body').scrollTop(this.$el.offset().top - 100);
    },
    initialize: function () {
      _.bindAll(this, 'render', 'segue', 'segueUrl', 'postBack', 'startPostBack', 'handleLightboxAcceptance');

      // This should be a collection of forms, prepopulated with the first.
      this.formviews = new FormViewArray();

      // Segue to the initial form id
      this.segue(this.options.initial_form_id);

      // There can be only one.
      this.$el.attr('id', 'NVTag' + (this.options.index + 1)).data('view', this);
    },
    segueUrl: function (url) {
      this.options.formUrl = url;
      var oberonUri = parseUrl(this.options.formUrl),
        oberonUrl = decodeURIComponent(oberonUri.pathname.split('/')[1]),
        oberonSegment = parseUrl(oberonUrl),
        formId = oberonSegment.pathname.split('/')[2];
      return this.segue(formId);
    },
    segue: function (new_id) {
      $('body').removeClass('page-ngp-multistep');
      this.$el.
        removeClass('fastaction-enabled multistep-layout nv-template-oberon nv-template-accelerator split-layout');
      /*jshint -W041 */
      if (this.currentFormView() != null && this.currentFormView().multistep && this.currentFormView().parentOptions) {
        /*jshint -W041 */
        this.options = _.extend(this.options, this.currentFormView().parentOptions);
      }

      // TODO: Stop setting irrelevant crap on the NVForm model!!!!
      var newForm = new NVForm({
        id: new_id,
        options: this.options
      });

      // Fetch the next form
      // Future performance enhancement -- we should not wait until segue to request
      // the next form, we can/should request it prior to segue and have it sitting, waiting
      // to significantly speed this process along.
      var newFormView = this.newNVFormView(newForm);

      // If this form was segued into from a previous form. Then previous form values
      // need to populate this form.
      /*jshint -W041 */
      if (this.currentFormView() != null) {
        /*jshint +W041 */
        var seguedFromLastForm_databag = new DatabagModel({name: 'seguedFromLastFormState'});
        seguedFromLastForm_databag.setWithFormState(this.currentFormView().options.last_form_state);
        newFormView.options.last_form_state = seguedFromLastForm_databag.getDict();
        this.currentFormView().remove();
      }

      this.formviews.push(newFormView);
      this.formviews.setCurrent(newFormView);

      var qs = this.options.query_string;
      if (qs.redirect) {

        var leftPointingTriangle = '&#x25c0;';
        var isIOS = navigator.userAgent.match(/(iPhone|iPod|iPad)/);

        if(isIOS){
          //prevent IOS from displaying unicode as emoji
          var noEmojiIOS = '&#xFE0E;';
          leftPointingTriangle += noEmojiIOS;
        }

        // Add link back to MiniVAN application
        this.$el.append('<a id="rta-link" class="btn-at btn-at-primary">' + leftPointingTriangle + ' Back to MiniVAN</a>');
      }
      this.$el.append(newFormView.$el);

      return this.render();
    },
    newNVFormView: function (form) {
      var formview = new NVFormView({
        model: form,
        parent: this,
        parent_tag: this,
        labels: this.options.labels,
        query_string: this.options.query_string,
        profile_databag: this.options.profile_databag,
        recipient_databag: this.options.recipient_databag,
        fast_action_databag: this.options.fast_action_databag,
        post_response: this.options.post_response || null,
        previous_payment: this.options.previous_payment || null,
        inline_error_display: this.options.inline_error_display,
        mobileAutofocus: this.options.mobileAutofocus
      });
      formview.parent = this;
      return formview;
    },
    spin: function ($target) {
      if (Spinner) {
        $target.spin();
      }
      return this;
    },
    setupShareUrls:function(){

        var  qs_field_dict = this.qs_field_dict;
        // The markup for the facebook and twitter buttons comes with the thankyou text.
        // It does require a click handler which we need to define and register here to support embedded forms
        var facebookShareButton = this.$('#fbShareBtn');
        var trackingId = formview.model.get('trackingId');
        // Make sure the share button is on the page
        if (facebookShareButton.length){
            var fbTrackingUrl = $('#fbShareBtn').attr('data-trackingurl');
            var doNotModifyForEmbeddedFb = typeof $('#fbShareBtn').attr('data-donotmodifyforembedded') !== 'undefined';
            // Register a click handler.
            // Using jquery instead of backbone-foo to register the callback
            facebookShareButton.click(function(event){
                event.stopPropagation();
                // Disable the button to avoid double clicks/race conditions
                facebookShareButton.prop('disabled',true);
                // Record somewhere that the social media button was clicked
                if (trackingId){
                  socialMediaLogger.recordActivity(formview.form_definition().url.full, trackingId, 'Facebook', function(){
                    facebookShareButton.prop('disabled', false);
                  });
                }
                socialSharePopup.popupFunction(event, 'https://www.facebook.com/sharer.php?u=', fbTrackingUrl, doNotModifyForEmbeddedFb, 520, 350, qs_field_dict);

          });
        }
        var twitterShareButton = this.$('#twShareBtn');
        // Make sure the share button is on the page
        if (twitterShareButton.length ){
            var twTrackingUrl = $('#twShareBtn').attr('data-trackingurl');
            var tweetText = $('#twShareBtn').attr('data-text');
            var doNotModifyForEmbeddedTw = typeof $('#twShareBtn').attr('data-donotmodifyforembedded') !== 'undefined';
            // Register a click handler.
            // Using jquery instead of backbone-foo to register the callback
            twitterShareButton.click(function(event){
                event.stopPropagation();
                // Disable the button to avoid double clicks/race conditions
                twitterShareButton.prop('disabled',true);
                // Record somewhere that the social media button was clicked
                if (trackingId){
                  socialMediaLogger.recordActivity(formview.form_definition().url.full, trackingId, 'Twitter', function(){
                    twitterShareButton.prop('disabled', false);
                  });
                }
                if (tweetText){
                  socialSharePopup.popupFunction(event, 'https://twitter.com/intent/tweet?text=' + tweetText  + '&url=', twTrackingUrl, doNotModifyForEmbeddedTw, 550, 420, qs_field_dict);
                } else {
                  socialSharePopup.popupFunction(event, 'https://twitter.com/intent/tweet?url=', twTrackingUrl, doNotModifyForEmbeddedTw, 520, 350, qs_field_dict);
                }
          });
        }

    },
    render: function (html) {
      // empty() faster than html(null) see http://vq.io/YGVN01
      // NO LONGER USE empty() as it kills all Event binding!
      // this.$el.empty();

      // check ads
      checkAds();

      if (this.options.offline) {
        var message = '<p>Sorry, our form processing system is down right now. Please try again shortly.</p>';
        if (this.options.offline_message) {
          message = this.options.offline_message;
        }
        this.$el.html(message);
        return this;
      }

      // If specific HTML was passed in, render that. Used primarily for Thank You pages
      if (typeof html !== 'undefined') {
        // This should be redone as a template...
        this.$('.ngp-spinner').remove();
        this.currentFormView().$el
          .html('<div class="content thankYou"><section class="contributions">' + html + '</section></div>').show();

        this.setupShareUrls();
      } else if (!this.currentFormView()) {
        // TODO: un-kludge
        return;
      } else if (this.interstitial) {
        // If interstitial set to true, hide the form, show a spinner
        this.$('.thankYou').remove();
        this.currentFormView().$el.hide();
        var $spinner = $('<div id="progress-' + this.currentFormView().cid +
        '" class="ngp-spinner" style="width: 100%; height: 200px;"></div>');
        this.$el.append($spinner);
        this.spin($spinner);
      } else {
        // Hide the Spinner, show the form
        this.$('.ngp-spinner, .thankYou').remove();
        this.currentFormView().$el.show();
      }
      return this;
      // Render creates the divs to hold forms in the collection. Triggers for form rendering are totally independent.
    },
    postBack: function (e, form_state, skipSteps) {

      // Prevent hard form submit.
      if (_.isObject(e) && _.isFunction(e.preventDefault)) {
        e.preventDefault();
      }

      // disable all auto submitting to ensure we only ever try this once per tag
      this.disableAutoSubmit = true;

      var formview = this.currentFormView();

      if (formview.multistep && formview.getStepIndex() + 1 !== formview.steps.length && !skipSteps) {
        return formview.nextStep();
      }

      // Scroll back up to the top
      this.bringIntoView();

      var errors = formview.errors();
      if (errors.length) {
        invokeCallbacks('formErrors', {errors: errors});
        return formview.renderFeedback();
      }

      // TODO: This is symptomatic of a wider issue with the way we handle async data layers.
      // Should use async library. - Bjorn
      var form_elements = formview.form_definition().form_elements;
      var form_fields = FormDefUtils.fields(form_elements);
      var hidden_fields = _.filter(form_fields, {type: 'hidden'});

      // Since the contact information fieldset gets blown away on advocacy forms
      // Build the query string dictionary here and now, but only once
      if (!this.qs_field_dict) {
        this.qs_field_dict = _.transform(
          // The current formfiew references what was returned in the thank you response
          // we want the query strings from the original form/model
          FormDefUtils.querystring_dict(formview.form_definition().form_elements, 'queryString'),
          // The qs dict keys are all made lowercase so as to ensure case-insensitive behavior.
          // Since we're finding the union of the two key sets, we need to lower-case this as well.
          function (result, value, key) {
            result[key.toLowerCase()] = value;
          }
        );

        //Add smartlink query strings to the dictionary as well
        // We will want to ensure that these are also removed from the shared link
        // https://ngpvan.atlassian.net/browse/DIGITAL-9327
        // https://ngpvan.atlassian.net/browse/VAN-37038 Remove anything that might have been added by tge smartlinks
        _.extend(this.qs_field_dict, {
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
          emci: '',
          emdi: '',
          fn: '',
          mn: '',
          ln: '',
          em: '',
          add1: '',
          ci: '',
          st: '',
          pc: '',
          hp: '',
          mp: '',
          wp: '',
          ep: '',
          oc: '',
          p: '',
          s: '',
          smartlinkdata: '', //legacy smartlink qs from TGE
          contactdata: '' //encrypted smartlink qs from TGE
        });
      }


      var hidden_form_state = _.reduce(hidden_fields, function (memo, field) {
        // Exclude hidden values with an empty string value
        if (field.value !== '') {
          memo[field.name] = field.value;
        }
        return memo;
      }, {});

      // Add MarketSource and MailingId, if relevant.
      var qs = this.options.query_string;
      _.each(qsParams, function (val, key) {
        if (qs[key]) {
          hidden_form_state[val] = qs[key];
        }
      });

      if (hidden_form_state.MarketSource) {
        hidden_form_state.MarketSource = hidden_form_state.MarketSource.substring(0, 149);
      }

      if (formview.form_definition().designation) {
        hidden_form_state.designationName = formview.form_definition().designation.name;
      }

      // Get the current state of the form, store it on this form so we
      // can use it later to re-fill the form if it comes back with errors
      // from the POST.
      form_state = formview.options.last_form_state = form_state ?
        _.merge(formview.val(), form_state) :
        formview.val();

      var self = this;

      function getVgsValuesAndPostback() {
        // show spinner
        self.interstitial = true;
        self.render();

        return formview.getVgsValues().then(function (vgsValues) {
          vgsValues = vgsValues || {};
          var vgsKeys = Object.keys(vgsValues);
          _.forEach(vgsKeys, function (key) {
            // add copy of each with Redacted prefix
            vgsValues['Redacted' + key] = vgsValues[key];
          });

          form_state = _.merge(form_state, vgsValues);
          return self.startPostBack(e, formview, form_state, hidden_form_state, qs);
        }, function (vgsValuesErr) {
          console.error(vgsValuesErr);
          // hide spinner
          self.interstitial = false;
          self.render();
        });
      }

      function getRecaptchaValueAndPostback(next){
        return formview.getRecaptchaValues().then(function(recaptchaValues){
          form_state = _.merge(form_state, recaptchaValues);
          return next();
        }, function (err) {
          console.error(err);
          if(window.appInsights){
            try {
                var error = err || new Error('Recaptcha Execution Error');
                var metaData = {
                ErrorType: 'Recaptcha Exception',
                FormSessionId: formview.formSessionId,
                InternalAttempts: formview.captcha.internalAttempts
                };
                window.appInsights.trackException({exception: typeof(error) === 'string' ? new Error(error) : error, properties: metaData});
            } catch (logerr){
                // swallow
            }
        }
          // hide spinner
          self.interstitial = false;
          self.render();
        });
      }

      function captureFormImage(){
        // Do NOT put spinners before this call otherwise it will
        // break w/ an empty canvas being rendered
        return html2canvasWrapper.htmlToCanvas($(formview.$el)[0])
          .then(function (canvas) {
            var dataURI = canvas.toDataURL('image/png');
            form_state.formCaptureImage = dataURI.replace('data:image/png;base64,', '');
          })
          .then(getVgsValuesAndPostback);
      }

      try {
        // trigger captcha first to ensure it happens before displaying a spinner
        // then if the form has "captureFormImage" enabled, do the form capture
        // then get VGS fields
        // then initiate the postback
        var afterCaptcha = formview.form_definition().metadata.captureFormImage
          ? captureFormImage
          : getVgsValuesAndPostback;
        return getRecaptchaValueAndPostback(afterCaptcha);

      } catch(err){
        // hide spinner
        self.interstitial = false;
        self.render();
      }
    },
    handleLightboxAcceptance: function(originalResponse, formview) {
      // For now, assume all lightbox acceptance is an upsell, and all upsells have payment method views
      // Directly locate the payment method view, since we'll need to await the action it takes, making events not suitable
      
      // Update the contribution model to be aware of the proposed upsell state.  Necessary for handling validation.
      formview.contributionAmountModel.setProposedUpsellState(originalResponse.response.proposedUpsellRecurringAmount, 
        originalResponse.response.proposedUpsellOneTimeAmount);

      var paymentMethodView = formview.subviewsWithName('PaymentMethod');
      
      // If we're missing the payment view, hope the form config knows what its doing and let it continue
      // to process the upsell
      if (!paymentMethodView) {
        return $.Deferred().resolve();
      }

      paymentMethodView = paymentMethodView[0];
      return paymentMethodView.onUpsellAccepted();
    },
    startPostBack: function(e, formview, form_state, hidden_form_state, qs) {
      // Explicitly remove Signature Pad values everywhere because they are huge.
      // We have to keep formCaptureImage because it's needed to
      // generate PDFs (VAN) server side
      // Use explicit search to support IE
      form_state = _.omit(form_state, function(value, key) {
        return key.indexOf('SignaturePad_') === 0;
      });

      // fix any field values that should be aliased to something else
      // important to do this before any databag syncing
      aliasHelper.fixAliasSubmissionValues(formview.aliases, form_state);

      // Valid settings are "everybody", "me", and "nobody"
      if (this.databagShareSetting() === 'everybody') {
        this.options.profile_databag.setWithFormState(form_state).save();
      }

      form_state = _.extend(hidden_form_state, form_state);

      // Tell Oberon which type of form we're posting
      form_state.type = formview.form_definition().type;

      delete form_state.formSessionId;
      delete form_state.FormSessionId;
      form_state.FormSessionId = formview.formSessionId;

      delete form_state.BrowserName;
      form_state.BrowserName = deviceInfo.browser;

      delete form_state.DeviceType;
      form_state.DeviceType = deviceInfo.deviceType;

      // send the Action Profile Databag ID
      if (formview.options.profile_databag && formview.options.profile_databag.id) {
          form_state.actionProfileId = formview.options.profile_databag.id;
      }

      // 4 is the "This Date" option; if it's not the selected option, then don't send EndDate.
      if (form_state.EndDate === null || parseInt(form_state.SelectedDuration, 10) !== 4) {
        delete form_state.EndDate;
      }

      // Delete the "HostCommittee" key if it is null.
      if (form_state.HostCommittee === null || form_state.HostCommittee === 'null') {
        delete form_state.HostCommittee;
      }

      // remove unecessary payment method information from form post
      if (form_state.PaymentMethod !== 'paypal') {
        delete form_state.PayPalNonce;
      }

      if (form_state.PaymentMethod !== 'eft') {
        delete form_state.BankAccountNumber;
        delete form_state.BankAccountType;
        delete form_state.RoutingNumber;
      }

      if (form_state.PaymentMethod !== 'applepay') {
        delete form_state.PaymentResponseDetails;
      }

      if (form_state.PaymentMethod !== 'creditcard') {
        delete form_state.Account;
        delete form_state.ExpirationMonth;
        delete form_state.ExpirationYear;
        delete form_state.SecurityCode;
        delete form_state.CreditCardLastFour;
        delete form_state.CreditCardLastFourType;
      }

      if (e) {
        e.data = form_state;
        e.formview = formview;
        invokeCallbacks('onSubmit', e);
      } else {
        invokeCallbacks('onSubmit', {
          data: form_state,
          formview: formview
        });
      }

      var self = this;
      function handleErrorResponse(errors, serverResponse) {
        self.interstitial = false;
        delete self.options.query_string.tknfa;

        // Remove prior response to lightbox - we want to present to the user again after they correct errors
        delete form_state.LightboxResponse;

        self.render().$('[name="ConfirmationID"]').remove();
        formview.subviews.error_console.setServerErrors(errors).renderFeedback();

        // in case this form has recaptcha, we need to invalidate the token
        if(!serverResponse || serverResponse.captchaReset){
          formview.resetRecaptcha();
        }

        if(window.appInsights) {
          try {
            _.forEach(errors, function(error) {
              window.appInsights.trackTrace({
                message: 'ActionTag handleErrorResponse',
                properties: {
                  Details: error.text,
                  Severity: error.severity,
                  FormSessionId: formview.formSessionId
                }
              });
            });
          } catch (err) {
            //( * ___*) <('womp')
          }
        }
      }

      // Flatten object by forcing serialization of values.
      // Needed because oberon expects standard post string like this (e.g.):
      // FirstName=Bjorn&TicketHolders={'FirstName':'Joe','LastName':'Hill'}
      function serialize(state) {
        return _.reduce(state, function (memo, value, key) {
          if (_.isNull(value)) {
            return memo;
          }
          memo[key] = _.isString(value) ? value : JSON.stringify(value);
          return memo;
        }, {});
      }

      form_state = serialize(form_state);

      var success_callback = _.bind(function (response) {
        // Necessary because Oberon returns a true JSON object, Drupal returns a string
        // that must be parsed as JSON. In the future, we can remove this, but it needs
        // to stay here as long as Drupal passthrough used for anything.
        if (!_.isObject(response)) {
          response = JSON.parse(response);
        }

        // Store this PostBack data for use in later filling
        this.options.post_response = response.response;

        // If any errors, don't want to segue to next form
        if (response && response.errors && response.errors.length > 0) {
          handleErrorResponse(response.errors, response);
        } else {
          // This line of code is no longer called in the render function as it causes issues
          // with event bindings.  However, after the form is successfully submitted it is desirable to
          // clear out the element to prevent html id collisions when a new form is populated.
          //this.$el.empty();

          this.interstitial = false;

          var trueResponse = 'response' in response ? response.response : response;
          var confirmationParams = 'page' in response ? response.page : {};
          if (trueResponse.customerKey && trueResponse.ccInfoKey) {
            this.options.customerKey = trueResponse.customerKey;
            this.options.ccInfoKey = trueResponse.ccInfoKey;
          }
          else if (trueResponse.confirmationID) {
            this.options.confirmationID = trueResponse.confirmationID;
          }

          var submitText = formview.$('input[type="submit"]').text() || 'Contribute';
          var amount = 0;
          if (form_state.Amount) {
            amount = Math.round(form_state.Amount);
            amount = _.isNaN(amount) ? 0 : amount;
          }

          nvtag.track(form_state.type, 'Form Submit', submitText, amount, formview);
          trackTransaction(formview, trueResponse);
          invokeCallbacks('preSegue', {
            formdef: formview.model.toJSON(),
            postVals: formview.val(),
            response: trueResponse,
            confirmation: confirmationParams
          });

          var duration = ~~((_.now() - formview.startTime) / 1000);
          window.onbeforeunload = null;

          if (response.response) {
            var res = response.response;
            this.options.profile_databag.set(_.extend(res, {
              ContributionDateTimeStamp: res.contributionDateTimeStamp,
              ContributionDateTime: res.contributionDateTimeStamp,
              ContributionAmount: accounting.formatMoney(res.contributionAmount),
              ContributionType: res.contributionType,
              ConfirmationID: res.confirmationID,
              PaymentConfirmationId: res.confirmationID,
              CC4Digit: res.cc4Digit,
              CreditCardLast4: res.cc4Digit,
              CCType: res.ccType,
              CreditCardType: res.ccType,
            }));
          }

          switch (response.page.confirmationActionType) {
            // Secondary ask form
            case 1:
            case 'InternalPage':
              if (form_state.autoCreateAccount) {
                require('fastActionUser').fetch({cache: false});
              }
              nvtag.track(form_state.type, 'Form Redirect', 'Secondary Ask', duration, formview);
              this.options.previous_payment = {};
              _.each(['Account', 'ExpirationMonth', 'ExpirationYear'], function(key){
                if (form_state[key]) {
                  this.options.previous_payment[key] = form_state[key];
                }
              }, this);
              if (response.page.confirmationRedirectFormUrl) {
                this.segueUrl(response.page.confirmationRedirectFormUrl);
              } else {
                if (this.options.formUrl) {
                  this.options.formUrl = null;
                }
                this.segue(response.page.confirmationRedirectFormId);
              }
              break;
            // External URL
            case 2:
            case 'ExternalPage':
              nvtag.track(form_state.type, 'Form Redirect', 'External URL', duration, formview);

              // DO NOT USE this.options.query_string, since nvtag.js (where is created)
              // forces all qs keys to lowercase
              // if the redirect url includes query strings just append these query strings to the end
               //remove first character, which will always be '?'
              window.location = response.page.confirmationRedirectUrl +
                (window.location.search ?
                  (response.page.confirmationRedirectUrl.indexOf('?') >= 0 ? '&' : '?') +
                  window.location.search.substring(1)
                  : '');

              break;
            // Thank you message
            case 3:
            case 'DisplayContent':
              nvtag.track(form_state.type, 'Form Redirect', 'Thank You', duration, formview);
              var html;
              var formdef = formview.form_definition();

              // Advocacy forms do not have the thank you page content in the formdef
              // so first check the page response
              if(response && response.page && response.page.confirmationPageContent){
                html = response.page.confirmationPageContent;
              } else {
                html = formdef.confirmation && formdef.confirmation.page_content ?
                  DoubleBracket.translate(formdef.confirmation.page_content) : '';
              }

              if (qs.redirect) {
                var cbData = _.reduce(qsParams.minivan, function(memo, key){
                  if (form_state[key]) {
                    memo[key] = form_state[key];
                  }
                  return memo;
                }, {
                  ConfirmationID: response.response.confirmationID,
                  TrackingID: response.response.trackingId
                });
                try {
                  cbData.SelectedDuration = formview.getField('SelectedDuration').def.options[cbData.SelectedDuration].display;
                  cbData.SelectedFrequency = formview.getField('SelectedFrequency').def.options[cbData.SelectedFrequency].display;
                } catch (e) {}
                var cb = qs.redirect + '?' + $.param(cbData);
                this.$('#rta-link').attr('href', cb);
                var redirectAfter = parseInt(qs.redirectafter, 10);
                if (redirectAfter) {
                  setTimeout(function(){
                    window.location = cb;
                    window.close();
                  }, redirectAfter * 1000);
                  html += '<br>Click the link at the top if you\'re not returned to MiniVAN in ' + redirectAfter + ' seconds.';
                }
              }
              // Store off the tracking id.  We're going to need it when we post recuiter tracking clicks
              formview.model.set({'trackingId': response.response.trackingId});

              this.render(html);

              // load maps if there any
              Map.loadMap('at-event-map-container');

              if (window.FB && window.FB.XFBML) {
                window.FB.XFBML.parse(this.el);
              }

              if (window.twttr && window.twttr.widgets) {
                var loc = window.location;
                var shareUrl = loc.protocol + '//' + loc.hostname + loc.pathname;
                this.$('a[href="https://twitter.com/share"]').attr('data-url', shareUrl);
                window.twttr.widgets.load(this.el);
              }

              invokeCallbacks('postRender', {
                form_definition: null,
                options: this.options,
                thank: true
              });

              var fill_dict = {};
              if (this.databagShareSetting() === 'everybody') {
                // We should clean up this fill_dict stuff so it's all handled consistently in one place.
                fill_dict = _.extend(this.options.profile_databag.getDict(), response.response);
              } else {
                fill_dict = _.extend({}, response.response, form_state);
                var fullName = '';
                if (fill_dict.FirstName) {
                  fullName += fill_dict.FirstName;
                }
                if (fill_dict.MiddleName) {
                  if (fullName) {
                    fullName += ' ';
                  }
                  fullName += fill_dict.MiddleName;
                }
                if (fill_dict.LastName) {
                  if (fullName) {
                    fullName += ' ';
                  }
                  fullName += fill_dict.LastName;
                }
                fill_dict.FullName = fullName;
              }

              DoubleBracket.fill(this, fill_dict);
              invokeCallbacks('segue', {
                formviews: this.formviews,
                thank: true,
                calling_tag: this
              });
              break;
            case 4:
            case 'Lightbox':
              var self = this;
              // If we successfully upsell the donor, in some cases we'll need to have them reauthorize their payment
              // This preAccept method returns a promise indicating whether they needed to authorize but did not.
              var preAcceptCallback =  function() {
                return self.handleLightboxAcceptance(response, formview);
              };
              var postAcceptCallback = function() {
                // Once the supporter accepts and any necessary work has been done, 
                // submit the form as accepted
                return self.postBack(null, { LightboxResponse: 'accept' }, true);
              };
              var declineCallback = function() {
                // Unset any proposed upsell state after a decline
                formview.contributionAmountModel.setProposedUpsellState(0, 0);

                // If the supporter declines, submit the form with that value
                return self.postBack(null, { LightboxResponse: 'decline' }, true);
              };

              var lightbox = lightboxHelper(response.page.lightboxData, declineCallback, preAcceptCallback, postAcceptCallback);
              this.render();
              lightbox.show();
              break;
          }
        }
      }, this);

      var error_callback = _.bind(function (xhr, textStatus, errorThrown) {
        var response = {};
        this.interstitial = false;

        if (xhr.responseText) {
          response = JSON.parse(xhr.responseText);
        }

        if (textStatus === 'timeout') {
          console.warn('Unfortunately, a timeout occurred.');
        } else {
          console.warn(response.message || 'Unspecified Error');
        }

        if(window.appInsights) {
          try {
            window.appInsights.trackTrace({
              message: 'ActionTag Form POST error',
              properties: {
                Details: response.message || 'Unspecified Error',
                Severity: 'Critical',
                TextStatus: textStatus,
                ErrorThrown: errorThrown,
                FormSessionId: formview.formSessionId
              }
            });
          } catch (err) {
          }
        }

        var messageText = formview.options.form_definition.resources.PrimaryResources.ProblemProcessingSubmission;
        var error = [{properties: ['Unknown'], severity: 'Critical', text: messageText}];
        handleErrorResponse(error);

      }, this);

      var body = {
        data: form_state,
        url: this.options.endpoint,
        form_id: formview.model.id,
        form_definition: formview.form_definition()
      };

      if (formview.form_definition().submissionUrl) {
        body.url = formview.form_definition().submissionUrl;
        body.form_id = '';
      }

      body.endpoint = body.url;

      var post = invokeCallbacks('alterPost', body);

      if (!post.data.Account) {
        if (this.options.customerKey && this.options.ccInfoKey) {
          post.data.CustomerKey = this.options.customerKey;
          post.data.CcInfoKey = this.options.ccInfoKey;
        } else if (this.options.confirmationID) {
          post.data.ConfirmationID = this.options.confirmationID;
        }
      }

      if(window.appInsights) {
        // check if any of the inputs in the form's DOM have the autofill pseudo-class
        // so we can determine if the values was sourced by autofill prior to submit
        try {
          var results = _.map(formview.$el.find(':-webkit-autofill'), function(el) {
            var data = _.pick(el, 'name', 'tagName', 'type', 'value');
            if(!_.contains(databag_config.allowlist, data.name)){
              // redact if it isnt in our allowlist
              data.value = (data.value||'').toString().replace(/./g, '*');
              data.redacted = true;
            }
            return data;
          });
          if(results && results.length){
            window.appInsights.trackEvent({name: 'ActionTag Autofill', properties: {
              Names: _.map(results, 'name').join(','),
              Details: JSON.stringify(results),
              FormSessionId: formview.formSessionId
            }});
          }
        } catch (err){
          // womp
        }
      }

      function postForm(){
        return oberon.post_form(post.url, post.form_id, post.data, success_callback, error_callback);
      }

      return postForm();
    }
  });
});

